import { OptimizedSearchResponse } from '@rover/rsdk/src/apiClient/latest';
import { PriceTransparencyLevels } from '@rover/types/src/PriceTransparencyLevel';

export default function fetchSearchResponseFactory(
  opts?: Partial<OptimizedSearchResponse>
): OptimizedSearchResponse {
  return {
    searchUuid: '',
    count: 0,
    pageCount: 0,
    results: [],
    paginatedCallouts: [],
    callouts: [],
    alternateSearch: {
      results: [],
    },
    bestMatchSearch: {
      results: [],
    },
    ...opts,
    derivedData: {
      center: ['', ''],
      zoomlevel: 0,
      currencyIso: '',
      priceFilterMaxValue: 0,
      priceFilterMinValue: 0,
      PriceTransparencyLevel: PriceTransparencyLevels.none,
      shouldPreferCatReviews: false,
      zoomMethod: '',
      starSitterLink: '',
    },
  };
}
